import React from 'react'
import {MainLeftTitle,CreateButton } from '../../../_uiComponents/WrapperComponents'
import { useNavigate } from "react-router-dom";



function MarcomsWrapper() {
    const navigate = useNavigate();
    const handleComms = () =>{ 
        let path = `/ui/create-marcoms`; 
        navigate(path);
      }
  return (
    <div className='sbt-data-grid__wr'>
        <MainLeftTitle title="Marcoms Management">
            <CreateButton onClick={handleComms} name="Create Comms"/>
        </MainLeftTitle>
    </div>
  )
}

export default MarcomsWrapper